module.exports = __webpack_public_path__ + "static/media/td-synnex.bd4780e1.svg";